<template>
  <div class="buildings">
    <Tooltip :visible="tooltip.visible" :horizontal="true">
      <BuildingTooltip :building="tooltip.data"></BuildingTooltip>
    </Tooltip>

    <div class="buildings__background">
      <img
        :src="
          require(`@/assets/${this.currentInvestment.assetsDirectory}/${this.buildingsDir}/${this.currentInvestment.buildingsBackground}`)
        "
        alt
      />
    </div>
    <div class="buildings__map" @click="enterBuilding">
      <component :is="svgmap"></component>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { validateInvestment } from '@/plugins/routeValidator';
import Tooltip from '@/components/tooltip.vue';
import BuildingTooltip from '@/components/building/building-tooltip.vue';

export default {
  name: 'investment',
  data() {
    return {
      tooltip: {
        visible: false,
        data: '',
      },
    };
  },
  components: { Tooltip, BuildingTooltip },
  computed: {
    ...mapState({
      currentInvestment: state => state.browser.currentInvestment,
      buildingsDir: state => state.browser.buildingsDir,
      flats: state => state.browser.flats,
    }),
    svgmap() {
      try {
        return this.currentInvestment.buildingsMap;
      } catch (e) {
        return null;
      }
    },
    buildings() {
      try {
        return [...this.currentInvestment.buildings].map(([key, building]) => {
          return { active: building.active, name: building.name };
        });
      } catch (error) {
        return [];
      }
    },
  },
  watch: {
    buildings() {
      this.initBuildings();
    },
    // TODO: filters
    // filters(currValue) {
    //   this.sendFiltersToUrl(currValue);
    // },
  },
  methods: {
    initBuildings() {
      let svgList = $('.buildings__map svg').children();
      svgList.each((index, building) => {
        building = $(building);
        if (building.children()) {
          building = building.children();
        }
        let name = building.data('building');
        building.removeClass('active');
        for (let b in this.buildings) {
          if (
            String(this.buildings[b].name).toLowerCase() ==
              String(name).toLowerCase() &&
            this.buildings[b].active
          ) {
            building.addClass('active');
          }
        }
        building.mouseenter(e => {
          if ($(e.target).hasClass('active')) {
            this.tooltip.visible = true;
            this.tooltip.data = name;
          }
        });
        building.mouseleave(e => {
          if ($(e.target).hasClass('active')) {
            this.tooltip.visible = false;
          }
        });
      });
    },
    enterBuilding(e) {
      let name = $(e.target).data('building');
      for (let b in this.buildings) {
        if (
          String(this.buildings[b].name).toLowerCase() ==
            String(name).toLowerCase() &&
          this.buildings[b].active
        ) {
          this.$router.push({
            path: `/${this.currentInvestment.url}/building/${String(
              name
            ).toUpperCase()}`,
            params: { building: String(name).toUpperCase() },
          });
        }
      }
    },
    //TODO: FILTERS
    // ...mapMutations({
    //   addFilter: "ADD_FILTERS",
    //   deleteFilter: "DELETE_FILTER",
    // }),
    // stringifyFilters(filters) {
    //   let obj = {};
    //   for (let filter of filters) {
    //     obj[filter.property] = {
    //       from: filter.from,
    //       to: filter.to,
    //     };
    //   }
    //   return qs.stringify(obj);
    // },
    // parseFilters(string) {
    //   let obj = qs.parse(string);
    //   let filters = [];
    //   for (let key in obj) {
    //     filters.push({
    //       property: key,
    //       ...obj[key],
    //     });
    //   }
    //   return filters;
    // },
    // buildingFilter(name) {
    //   if (name) {
    //     this.addFilter({
    //       property: this.flatProperties["building"],
    //       equal: name,
    //       constant: true,
    //     });
    //   } else {
    //     this.deleteFilter({
    //       property: this.flatProperties["building"],
    //       constant: true,
    //     });
    //   }
    // },
    // floorFilter(floor) {
    //   if (floor) {
    //     this.addFilter({
    //       property: this.flatProperties["floor"],
    //       equal: floor,
    //       constant: true,
    //     });
    //   } else {
    //     this.deleteFilter({
    //       property: this.flatProperties["floor"],
    //       constant: true,
    //     });
    //   }
    // },
    // sendFiltersToUrl(filters) {
    //   let fltrs = this.stringifyFilters([...filters]) || undefined;
    //   this.$router
    //     .replace({
    //       path: this.$route.path,
    //       query: { ...this.$route.query, filters: fltrs },
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },
  },
  beforeRouteEnter(to, from, next) {
    if (validateInvestment(to.params)) {
      next();
    } else {
      next('/404');
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (validateInvestment(to.params)) {
      next();
    } else {
      next('/404');
    }
  },
  beforeMount() {
    if (!this.currentInvestment.multiBuilding) {
      this.$router.replace(
        `${this.currentInvestment.url}/building/${this.buildings[0].name}`
      );
    }
  },
  mounted() {
    this.initBuildings();

    // filters TODO:
    //     if (this.$route.query.filters) {
    //   this.$store.commit(
    //     "ADD_FILTERS",
    //     this.parseFilters(this.$route.query.filters)
    //   );
    // }
    // this.buildingFilter(this.$route.params.building);
    // this.floorFilter(this.$route.params.floor);
  },
};
</script>

<style lang="scss">
.buildings {
  flex: 1;
  display: flex;
  overflow-x: hidden;
}

.buildings__background {
  width: 100%;
  height: $noTopbarHeight;
  flex: 1;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.buildings__map {
  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;

    g {
      &:hover {
        polygon,
        polyline,
        rect {
          opacity: 0.6 !important;
          fill-opacity: 0.8 !important;
        }
      }
    }

    polyline,
    polygon,
    rect {
      fill: #ccc !important;
      opacity: 0 !important;
      fill-opacity: 0 !important;
      cursor: not-allowed;
      pointer-events: initial;
      transition: 250ms;
      display: block !important;

      &:hover {
        opacity: 0.6 !important;
        fill-opacity: 0.8 !important;
      }

      &.active {
        fill: #ffe4b8 !important;
        cursor: pointer;
        // opacity: 0.55!important;
        // fill-opacity: 0.75 !important;
      }
    }
  }
}
</style>
